<template>
  <div class="panel panel-primary student-view__panel-personal-data">
    <div class="panel-body">
      <ul class="nav nav-tabs">
        <li class="tabulated-list active" role="presentation">
          <a data-toggle="tab" href="#personal-data-student">
            Dados do aluno
          </a>
        </li>
        <li class="tabulated-list" role="presentation">
          <a data-toggle="tab" href="#personal-data-cards">
            Cartões
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <section class="tab-pane fade in active" id="personal-data-student">
          <student-data />
        </section>
        <section class="tab-pane fade" id="personal-data-cards">
          <cards />
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import StudentData from './StudentData';
import Cards from './Cards';

export default {
  components: {
    StudentData,
    Cards,
  },
};
</script>
